import { FormattedMessage, useIntl } from 'react-intl'
import {
  CustomInputs,
  ErrorMessage,
  FloatingLabel,
  FormContainer,
  LabelMessage
} from '../../../../components/form-fields/styled-components'

import { InsideFormContainer } from '../../styled-components'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'
import ButtonComponent from '../../../../components/stories/atoms/button'

const LoginForm = ({
  email,
  emailMissing,
  password,
  passwordMissing,
  handleSetEmail,
  handleSetPassword,
  emailVerifying,
  handleLogin
}) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <FormContainer>
        <FloatingLabel visible={!!email || emailMissing}>
          {!emailMissing
            ? (
            <LabelMessage>
              <FormattedMessage id="registerForm_email" />
            </LabelMessage>
              )
            : (
            <ErrorMessage data-testid="Login-errorMsg-email">
              <FormattedMessage id="registerForm_validEmail" />
            </ErrorMessage>
              )}
        </FloatingLabel>
        <CustomInputs
          data-testid="Login-input-email"
          autoFocus
          type="email"
          placeholder={formatMessage({
            id: 'registerForm_email'
          })}
          value={email}
          onChange={handleSetEmail}
          wrongInput={emailMissing}
        />
      </FormContainer>
      <FormContainer>
        <InsideFormContainer>
          <FloatingLabel visible={!!password || passwordMissing}>
            {!passwordMissing
              ? (
              <LabelMessage>
                <FormattedMessage id="registerForm_password" />
              </LabelMessage>
                )
              : (
              <ErrorMessage data-testid="Login-errorMsg-password">
                <FormattedMessage id="registerForm_validPassword" />
              </ErrorMessage>
                )}
          </FloatingLabel>
          <CustomInputs
            data-testid="Login-input-password"
            type="password"
            value={password}
            placeholder={formatMessage({
              id: 'registerForm_password'
            })}
            onChange={handleSetPassword}
            wrongInput={passwordMissing}
          />
        </InsideFormContainer>
      </FormContainer>
      {!emailVerifying && (
        <FormContainer center>
          <ButtonComponent
            fullWidth={true}
            variant={buttonVariantOptions.PRIMARY}
            size={buttonSizeOptions.LARGE}
            onClick={handleLogin}
            data-testid="Login-button-login"
            style={{ marginTop: '30px' }}
          >
            <FormattedMessage id="registerform_login" />
          </ButtonComponent>
        </FormContainer>
      )}
    </>
  )
}

export default LoginForm
